import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { CartProvider } from "./services/CartContext";
import { AuthProvider } from "components/auth/AuthContext";
import { BrowserRouter } from "react-router-dom";
import { NotificationProvider } from "context/NotificationContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
const queryClient = new QueryClient();
root.render(
  <GoogleOAuthProvider clientId="287191984186-c180mlhdag7jioh9ljesfhbglbps2ad4.apps.googleusercontent.com">
    <BrowserRouter>
      <AuthProvider>
        <React.StrictMode>
          <QueryClientProvider client={queryClient}>
            <CartProvider>
              <NotificationProvider>
                <App />
              </NotificationProvider>
            </CartProvider>
          </QueryClientProvider>
        </React.StrictMode>
      </AuthProvider>
    </BrowserRouter>
  </GoogleOAuthProvider>
);
